import('./bootstrap')

const origin = console.error;
console.error = (error) => {
	if (/Loading chunk [\d]+ failed/.test(error.message)) {
		alert('A new version released. Need to relaod the page to apply changes.')
		window.location.reload();
	} else {
		origin(error);
	}
}

window.addEventListener('unhandledrejection', function (e) {
	if (/Loading chunk [\d]+ failed/.test(e.reason.message)) {
		alert('A new version released. Need to relaod the page to apply changes.')
		window.location.reload();
	}
})

